import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EmbeddedIdeasEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const embeddedIdeasEntryPoint: EntryPoint<EmbeddedIdeasEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<EmbeddedIdeasEntryPointComponent>(
			/* webpackChunkName: "async-polaris-embedded-ideas-entrypoint" */ './PolarisEmbeddedIdeasPage.tsx',
		),
		getPreloadProps: () => ({}),
	});
